import { Map, List } from 'immutable';
import { SUCCESS, ERROR } from '@actions/global';
import * as propertyActions from '../actions/equityFinder/property';
import * as masterActions from '../actions/equityFinder/master';
import * as globalEquityFinderActions from '../actions/equityFinder/global';
import * as versionActions from '../actions/equityFinder/version';
import * as regressionActions from '../actions/equityFinder/regression';
import * as presentationActions from '../actions/equityFinder/presentation';
import * as dashboardUIActions from '../actions/equityFinder/dashboard';
import * as configurationsActions from '../actions/equityFinder/configurations';
import * as dataloadActions from '../actions/equityFinder/dataload';

import * as globalMaintenanceActions from '../actions/maintenance/global';
import * as roleActions from '../actions/maintenance/role';
import * as usersActions from '../actions/maintenance/users';
import * as taxMaintenanceActions from '../actions/maintenance/taxTransparency';
import * as websiteAdminActions from '../actions/maintenance/websiteAdmin';

import * as globalMraActions from '../actions/mra/global';
import * as mraActions from '../actions/mra/mra';

import * as globalAppraisalDemoActions from '../actions/appraisalDemo/global';
import * as appraisalDemoZillowActions from '../actions/appraisalDemo/zillow';
import * as appraisalDemoSearchActions from '../actions/appraisalDemo/search';

import * as globalAppraisalActions from '@modules/appraisal/actions/global';
import * as appraisalOwnerActions from '@modules/appraisal/actions/owner';
import * as appraisalAgentActions from '@modules/appraisal/actions/agent';
import * as appraisalBuildingPermitActions from '@modules/appraisal/actions/buildingpermit';
import * as appraisalMortgagelenderActions from '@modules/appraisal/actions/mortgagelender';
import * as appraisalPropertyActions from '@modules/appraisal/actions/property';
import * as appraisalEconomicUnitActions from '@modules/appraisal/actions/economicunits';

import * as toastActions from '../actions/toast';
import * as globalActions from '../actions/global';
import * as globalUserActions from '../actions/user';

import * as eventsActions from '@modules/events/actions/eventform';
import * as eventActions from '@modules/events/actions/event';
import * as eventsRolesActions from '@modules/events/actions/roles';

import * as assessmentExemptionActions from '@modules/assessment/actions/exemption';
import * as assessmentTaxingUnitActions from '@modules/assessment/actions/taxingUnit';
import * as assessmentTaxingUnitDocActions from '@modules/assessment/actions/document';

import * as litigationPropertiesActions from '@modules/litigation/actions/properties';
import * as litigationCaseActions from '@modules/litigation/actions/case';
import * as litigationConfigurationActions from '@modules/litigation/actions/configuration';
import * as litigationPartiesActions from '@modules/litigation/actions/parties';
import * as litigationFirmActions from '@modules/litigation/actions/firm';

import * as appraisalAdminExportActions from '@modules/appraisalAdmin/actions/export';
import * as appraisalAdminLandModelActions from '@modules/appraisalAdmin/actions/landModels';
import * as appraisalAdminOfficeInfoActions from '@modules/appraisalAdmin/actions/officeInfo';
import * as appraisalAdminDataEntryActions from '@modules/appraisalAdmin/actions/dataEntry';
import * as appraisalAdminIncomeModelsActions from '@modules/appraisalAdmin/actions/incomeModels';
import * as appraisalAdminBppRenditionActions from '@modules/appraisalAdmin/actions/bppRendition';
import * as appraisalAdminTIRZActions from '@modules/appraisalAdmin/actions/tirz';
import * as appraisalAdminNoticeActions from '@modules/appraisalAdmin/actions/notice';
import * as appraisalAdminRecalcActions from '@modules/appraisalAdmin/actions/recalculation';
import * as appraisalAdminRollCorrectionActions from '@modules/appraisalAdmin/actions/rollCorrection';
import * as appraisalAdminAppealCheckInActions from '@modules/appraisalAdmin/actions/appealCheckIn';
import * as pricingTableActions from '@modules/appraisalAdmin/actions/pricingTable';
import * as appraisalAdminGlobalActions from '@modules/appraisalAdmin/actions/global';
import * as appraisalAdminModelActions from '@modules/appraisalAdmin/actions/models';

import * as appealsActions from '@modules/appeals/actions/appeals';
import * as docketActions from '@modules/appeals/actions/dockets';
import * as biSmartListsActions from '@modules/bi/actions/smartLists';
import * as queueWorkTypesActions from '@modules/queue/actions/worktypes';
import * as queueSettingActions from '@modules/queue/actions/queuesetting';
import * as queueGlobalActions from '@modules/queue/actions/global';
import * as batchProcessingActions from '@modules/queue/actions/batchprocessing';

import * as ptdProcessActions from '@modules/processManager/actions/ptdProcess';
import * as bppPenaltyActions from '@modules/processManager/actions/bppPenalty';
import * as buildingPermitActions from '@modules/processManager/actions/buildingPermit';

import * as mobileAssignmentActions from '@modules/mobileManager/actions/assignment';
import * as mobileSearchActions from '@modules/mobileManager/actions/search';
import * as mobilePropertyActions from '@modules/mobileManager/actions/property';

import * as massUpdateActions from '@modules/analysis/actions/massUpdate';
import * as marketAreaActions from '@modules/analysis/actions/marketArea';

import * as conferencingActions from '@modules/conferencing/actions/global';
import * as conferenceActions from '@actions/conference';

import * as captureJanuary1OwnersActions from '@modules/processManager/actions/captureJanuary1Owners';

import * as massMatchSalesActions from '@modules/processManager/actions/massMatchSales';

function pushError(state, error, entity) {
  return state.push(Map({ type: 'error', error, entity }));
}

function pushWarning(state, error) {
  return state.push(Map({ type: 'warning', error }));
}

function pushSuccess(state, message) {
  return state.push(Map({ type: 'success', message }));
}

function pop(state) {
  return state.shift();
}

export default (state = List(), action) => {
  switch (action.type) {
    // error
    case globalUserActions.LOGIN_ERROR:
      return pushError(state, action.error, 'Authentication failed');

    case globalUserActions.RESET_MFA_ERROR:
      return pushError(state, action.error, 'Unable to reset MFA');

    case globalUserActions.RESET_PASSWORD_ERROR:
      return pushError(state, action.error, 'Unable to reset password');

    // EquityFinder actions
    case masterActions.MASTER_COPY_ERROR:
      return pushError(state, action.error, 'Copying Master');
    case masterActions.MASTER_ADD_ERROR:
      return pushError(state, action.error, 'Adding Master');
    case masterActions.MASTER_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Master');
    case masterActions.MASTER_REMOVE_ERROR:
      return pushError(state, action.error, 'Removing Master');

    case propertyActions.PROPERTY_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Property');
    case propertyActions.PROTEST_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Protest');
    case propertyActions.PROPERTY_FETCH_FIELDS_ERROR:
    case globalEquityFinderActions.PREFERENCE_FETCH_ERROR:
    case propertyActions.PROPERTY_FETCH_SEARCH_OPTIONS_ERROR:
    case propertyActions.PROPERTY_FETCH_SEARCH_RULES_ERROR:
    case globalEquityFinderActions.PREFERENCE_PERSIST_ERROR:
      return pushError(state, action.error, 'Fetching Configuration');

    case globalEquityFinderActions.CACHE_REFRESH_ERROR:
      return pushError(state, action.error, 'Refreshing Cache');

    case propertyActions.PROPERTY_SEARCH_ERROR:
    case masterActions.MASTER_COMP_PROPERTY_SEARCH_ERROR:
      return pushError(state, action.error, 'Searching Property');

    case propertyActions.PROPERTY_COMP_GRID_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Comp Grid Data');

    case propertyActions.PROPERTY_COMP_PDF_GENERATE_ERROR:
      return pushError(state, action.error, 'Generating Comp Grid PDF');

    case propertyActions.PROPERTY_COVER_PDF_GENERATE_ERROR:
      return pushError(state, action.error, 'Generating Cover Sheet PDF');

    case propertyActions.VERSION_COMPS_REORDER_ERROR:
      return pushError(state, action.error, 'Reordering Version Comps');

    case versionActions.VERSION_ADD_PROPERTY_ERROR:
      return pushError(state, action.error, 'Adding Property to Version');
    case versionActions.VERSION_CREATE_ERROR:
      return pushError(state, action.error, 'Creating Sersion');
    case versionActions.VERSION_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Version');
    case versionActions.VERSION_REMOVE_ERROR:
      return pushError(state, action.error, 'Removing Version');
    case versionActions.VERSION_REMOVE_PROPERTY_ERROR:
      return pushError(state, action.error, 'Removing Property from Version');
    case versionActions.VERSION_SET_ACTIVE_ERROR:
      return pushError(state, action.error, 'Setting Version Active');
    case versionActions.VERSIONS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Versions');
    case versionActions.VERSION_COPY_PROPERTY_ERROR:
      return pushError(state, action.error, 'Copying Version');
    case versionActions.VERSION_IMPORT_PROPERTY_ERROR:
      return pushError(state, action.error, 'Importing Property');
    case versionActions.VERSION_DESCRIPTION_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating Description');

    case presentationActions.PRESENTATION_DOCUMENTLIST_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Document List');
    case presentationActions.PRESENTATION_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Presentation');
    case presentationActions.PRESENTATION_DOCUMENT_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Document');
    case presentationActions.PRESENTATION_GLOBALDOCUMENT_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Global Document');
    case presentationActions.PRESENTATION_GLOBALDOCUMENT_UPLOAD_ERROR:
      return pushError(state, action.error, 'Uploading Global Document');
    case presentationActions.PRESENTATION_DOCUMENT_UPLOAD_ERROR:
      return pushError(state, action.error, 'Uploading Document');

    case presentationActions.PRESENTATION_DOCUMENT_GET_ERROR:
    case presentationActions.PRESENTATION_GLOBALDOCUMENT_GET_ERROR:
    case presentationActions.PRESENTATION_FINAL_DOCUMENT_GET_ERROR:
      return pushError(state, action.error, 'Opening Document');

    case presentationActions.PRESENTATION_PUBLISHED_DOCUMENT_ADD_ERROR:
    case presentationActions.PRESENTATION_GLOBAL_DOCUMENT_ADD_ERROR:
      return pushError(state, action.error, 'Adding Document');

    case presentationActions.PRESENTATION_PUBLISH_ERROR:
      return pushError(state, action.error, 'Publishing Presentation');

    case presentationActions.PRESENTATION_FINAL_PRESENTATION_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching final Presentation');
    case presentationActions.PRESENTATION_ORDER_CHANGE_ERROR:
      return pushError(state, action.error, 'Changing Order');

    case presentationActions.PRESENTATION_TEMPLATE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching defaul Template');

    case regressionActions.REGRESSION_ANALYSIS_LIST_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Regression Analysis List',
      );

    case regressionActions.REGRESSION_ANALYSIS_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Regression Analysis');

    case regressionActions.REGRESSION_ANALYSIS_SET_ACTIVE_ERROR:
      return pushError(
        state,
        action.error,
        'Setting Regression Analysis as Default',
      );

    case regressionActions.REGRESSION_ANALYSIS_CREATE_ERROR:
      return pushError(state, action.error, 'Creating Regression Analysis');

    case regressionActions.REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Regression Analysis Property List',
      );

    case regressionActions.REGRESSION_ANALYSIS_PROPERTY_DELETE_ERROR:
      return pushError(
        state,
        action.error,
        'Deleting Regression Analysis Property',
      );

    case regressionActions.REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Regression Analysis Comp Properties',
      );

    case regressionActions.REGRESSION_ANALYSIS_COMP_ADD_ERROR:
      return pushError(
        state,
        action.error,
        'Adding Regression Analysis Comp Properties',
      );

    case regressionActions.REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Regression Analysis Rule Set Comp Properties',
      );

    case regressionActions.REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_ERROR:
      return pushError(state, action.error, 'Fetching Property Comp');

    case propertyActions.PROPERTY_CATEGORIES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Property Categories');

    case propertyActions.PROPERTY_CATEGORY_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Property Category');

    case propertyActions.PROPERTY_COMP_SEARCH_ERROR:
      return pushError(state, action.error, 'Fetching Property Comp');

    case propertyActions.PROPERTY_COMP_VALID_CHECK_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Property Comp valid data',
      );

    case propertyActions.PROPERTY_SCORE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Prodigy Score');

    case configurationsActions.CONFIGURATIONS_CATEGORY_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Category');

    case configurationsActions.CONFIGURATIONS_CATEGORY_ADD_ERROR:
      return pushError(state, action.error, 'Adding Category');

    case configurationsActions.CONFIGURATIONS_CATEGORY_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating Category');

    case configurationsActions.CONFIGURATIONS_CATEGORY_CONFIG_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Category Config');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESETS_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Category Regression Rule Sets',
      );

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_ADD_ERROR:
      return pushError(
        state,
        action.error,
        'Adding Category Regression Rule Set',
      );

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_EDIT_ERROR:
      return pushError(
        state,
        action.error,
        'Editing Category Regression Rule Set',
      );

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_DELETE_ERROR:
      return pushError(
        state,
        action.error,
        'Deleting Category Regression Rule Set',
      );

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Category Regression Rule Set',
      );

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULE_ADD_ERROR:
      return pushError(state, action.error, 'Adding Category Regression Rule');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULE_EDIT_ERROR:
      return pushError(state, action.error, 'Editing Category Regression Rule');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULE_DELETE_ERROR:
      return pushError(
        state,
        action.error,
        'Deleting Category Regression Rule',
      );

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULES_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Category Comp Selection Scoring Rules',
      );

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULE_ADD_ERROR:
      return pushError(
        state,
        action.error,
        'Adding Category Comp Selection Scoring Rule',
      );

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULE_EDIT_ERROR:
      return pushError(
        state,
        action.error,
        'Editing Category Comp Selection Scoring Rule',
      );

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULE_DELETE_ERROR:
      return pushError(
        state,
        action.error,
        'Deleting Category Global Scoring Rule',
      );

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Category Global Scoring Rules',
      );

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Category Global Scoring Rule',
      );

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_ERROR:
      return pushError(
        state,
        action.error,
        'Adding Category Global Scoring Rule',
      );

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_ERROR:
      return pushError(
        state,
        action.error,
        'Editing Category Global Scoring Rule',
      );

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_ERROR:
      return pushError(
        state,
        action.error,
        'Deleting Category Global Scoring Rule',
      );

    case configurationsActions.COMPGRID_CONFIGURATIONS_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Comp Grid Configurations',
      );

    case configurationsActions.COMPGRID_CONFIGURATIONS_SAVE_ERROR:
      return pushError(state, action.error, 'Saving Comp Grid Configurations');

    case configurationsActions.COMPGRID_OPTION_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Comp Grid Configuration');

    case configurationsActions.SYSTEM_CONFIGURATIONS_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Comp Grid Configurations',
      );

    case configurationsActions.SYSTEM_CONFIGURATIONS_SAVE_ERROR:
      return pushError(state, action.error, 'Saving Comp Grid Configurations');

    case configurationsActions.BASE_UNIT_LIST_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Base Unit List');

    case configurationsActions.BASE_UNIT_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Base Unit');

    case configurationsActions.BASE_UNIT_ADD_ERROR:
      return pushError(state, action.error, 'Adding Base Unit');

    case configurationsActions.BASE_UNIT_EDIT_ERROR:
      return pushError(state, action.error, 'Editing Base Unit');

    case configurationsActions.BASE_UNIT_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Base Unit');

    case configurationsActions.PRODIGY_SCORE_LIST_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Prodigy Score Configurations',
      );

    case configurationsActions.PRODIGY_SCORE_EDIT_ERROR:
      return pushError(
        state,
        action.error,
        'Editing Prodigy Score Configuration',
      );

    case configurationsActions.TEMPLATES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Templates');

    case configurationsActions.TEMPLATE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching a Template');

    case configurationsActions.TEMPLATE_CREATE_ERROR:
      return pushError(state, action.error, 'Creating a Template');

    case configurationsActions.TEMPLATE_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating a Template');

    case configurationsActions.TEMPLATE_DEFAULT_SET_ERROR:
      return pushError(state, action.error, 'Setting a default Template');

    case configurationsActions.TEMPLATE_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting a Template');

    case configurationsActions.TEMPLATE_CATEGORY_ADD_ERROR:
      return pushError(
        state,
        action.error,
        'Associating a Template to the Category',
      );

    case configurationsActions.TEMPLATE_CATEGORY_REMOVE_ERROR:
      return pushError(
        state,
        action.error,
        'Removing a Template from the Category',
      );

    case dataloadActions.DATA_IMPORT_ERROR:
      return pushError(state, action.error, 'Importing data');

    case dataloadActions.DATA_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching data');

    case dashboardUIActions.APPRAISER_STATUS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Appraiser Status');

    case dashboardUIActions.APPRAISERS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Appraisers');

    case dashboardUIActions.RECENT_EDITS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Recent Edits');

    case dashboardUIActions.EVIDENCE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching 14 Day Evidence');

    case dashboardUIActions.HOT_LIST_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Hot List');

    case dashboardUIActions.PROTEST_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Protest');

    case dashboardUIActions.TIME_LINES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Time Lines');

    case dashboardUIActions.TIME_LINE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Time Line');

    case dashboardUIActions.APPRAISER_CASE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Appraiser Case');
    // Maintenance actions
    case globalMaintenanceActions.PREFERENCE_FETCH_ERROR:
    case globalMaintenanceActions.PREFERENCE_PERSIST_ERROR:
      return pushError(state, action.error, 'Fetching Configuration');

    case roleActions.MODULES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Modules');

    case roleActions.ROLES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Roles');

    case roleActions.RIGHTS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Rights');

    case roleActions.ROLE_RIGHTS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Rights');

    case roleActions.ROLE_CREATE_ERROR:
      return pushError(state, action.error, 'Creating Role');

    case roleActions.ROLE_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Role');

    case roleActions.ROLE_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating Role');

    case roleActions.RIGHT_ASSIGN_ERROR:
      return pushError(state, action.error, 'Adding Right');

    case roleActions.RIGHT_UNASSIGN_ERROR:
      return pushError(state, action.error, 'Removing Right');

    case roleActions.ALL_RIGHTS_UNASSIGN_ERROR:
      return pushError(state, action.error, 'Removing All Rights');

    case usersActions.USERS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Users');

    case usersActions.USER_INACTIVATE_ERROR:
      return pushError(state, action.error, 'Inactivating User');

    case usersActions.USER_ACTIVATE_ERROR:
      return pushError(state, action.error, 'Activating User');

    case usersActions.USER_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting User');

    case usersActions.USER_CREATE_ERROR:
      return pushError(state, action.error, 'Creating User');

    case usersActions.USER_MODULES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching User Modules');

    case usersActions.USER_MODULE_ASSIGN_ERROR:
      return pushError(state, action.error, 'Assigning User Module');

    case usersActions.USER_MODULE_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting User Module');

    case usersActions.USER_ROLES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching User Roles');

    case usersActions.USER_MODULE_ROLE_ADD_ERROR:
      return pushError(state, action.error, 'Adding User Module Role');

    case usersActions.USER_MODULE_ROLE_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting User Module Role');

    case usersActions.USER_INIT_ERROR:
      return pushError(state, action.error, 'Resetting User Password');

    case usersActions.USER_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating User Password');

    case usersActions.TAXING_UNITS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Taxing Units');

    case usersActions.USER_TAXING_UNITS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching User Taxing Units');

    case usersActions.USER_TAXING_UNITS_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating User Taxing Units');
    // mra actions
    case globalMraActions.PREFERENCE_FETCH_ERROR:
    case globalMraActions.PREFERENCE_PERSIST_ERROR:
      return pushError(state, action.error, 'Fetching Configuration');

    case mraActions.MRA_MODEL_SETTING_PERSIST_ERROR:
      return pushError(state, action.error, 'Persisting Settings');

    case mraActions.MRA_MODELS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Models');
    case mraActions.MRA_MODEL_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting a Model');
    case mraActions.MRA_MODEL_CREATE_ERROR:
      return pushError(state, action.error, 'Creating a Model');
    case mraActions.MRA_MODEL_CALCULATE_ERROR:
      return pushError(state, action.error, 'Calculating a Model');

    case mraActions.MRA_MODEL_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Model');
    case mraActions.MRA_ANALYSIS_FETCH_ERROR:
      return pushError(
        state,
        action.error,
        'Fetching Analysis Characteristics Model',
      );
    case mraActions.MRA_ANALYSIS_NOI_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Analysis NOI Model');

    // appraisal actions
    case globalAppraisalDemoActions.PREFERENCE_FETCH_ERROR:
    case globalAppraisalDemoActions.PREFERENCE_PERSIST_ERROR:
    case globalAppraisalActions.PREFERENCE_FETCH_ERROR:
    case globalAppraisalActions.PREFERENCE_PERSIST_ERROR:
      return pushError(state, action.error, 'Fetching Configuration');

    case appraisalDemoZillowActions.ZILLOW_ZESTIMATE_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Zillow Zestimate Data');

    case appraisalDemoZillowActions.ZILLOW_ZPROPERTY_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching ZProperty Detail Data');

    case appraisalDemoZillowActions.ZILLOW_ZCOMPS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching ZComps');

    case appraisalDemoSearchActions.PROPERTY_CODES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Codes');

    case appraisalDemoSearchActions.PROPERTY_SUBDIVISIONCODES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Subdivision Codes');

    case appraisalDemoSearchActions.SEARCH_OPTIONS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Search Options');

    case appraisalDemoSearchActions.PROPERTY_FIELDS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Search Fields');

    case appraisalDemoSearchActions.PROPERTY_SEARCH_ERROR:
      return pushError(state, action.error, 'Searching Property');

    case appraisalOwnerActions.OWNER_SEARCH_OPTIONS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Search Options');

    case appraisalOwnerActions.OWNER_FIELDS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Search Fields');

    case appraisalOwnerActions.OWNER_SEARCH_ERROR:
      return pushError(state, action.error, 'Searching Owners');

    case appraisalOwnerActions.OWNER_TAGS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Tags');

    case appraisalOwnerActions.OWNER_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Owner Detail');

    case appraisalOwnerActions.OWNER_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating Owner Detail');

    case appraisalOwnerActions.OWNER_NOTES_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Owner note');

    case appraisalOwnerActions.OWNER_NOTE_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting Owner note');

    case appraisalOwnerActions.OWNER_NOTE_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating Owner note');

    case appraisalOwnerActions.OWNER_NOTE_ADD_ERROR:
      return pushError(state, action.error, 'Adding Owner note');

    case appraisalOwnerActions.OWNER_VALIDATE_ERROR:
      return pushError(state, action.error, 'Validating Owner note');

    // events actions
    case eventsActions.EVENT_FORMS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Event Forms');
    case eventsActions.EVENT_FORM_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting an Event Form');
    case eventsActions.EVENT_FORM_CREATE_ERROR:
      return pushError(state, action.error, 'Creating an Event Form');
    case eventsActions.EVENT_FORM_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating an Event Form');
    case eventsActions.DATA_OBJECTS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Data Objects');
    case eventsActions.EVENT_GROUPS_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Event Groups');
    case eventActions.EVENT_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching an Event');
    case eventActions.EVENT_DELETE_ERROR:
      return pushError(state, action.error, 'Deleting an Event');
    case eventActions.EVENT_CREATE_ERROR:
      return pushError(state, action.error, 'Creating an Event');
    case eventActions.EVENT_UPDATE_ERROR:
      return pushError(state, action.error, 'Updating an Event');
    case eventActions.EVENT_UPDATE_TAG_OBJECT_ERROR:
      return pushError(state, action.error, 'Updating Event Tags/Objects');
    case eventActions.EVENT_INACTIVATE_ERROR:
      return pushError(state, 'Inactivating an Event');
    case eventsRolesActions.FORM_ASSOC_CREATE_ERROR:
      return pushError(state, 'Creating an Association');
    case eventsRolesActions.FORM_ASSOC_DELETE_ERROR:
      return pushError(state, 'Deleting an Association');

    //  litigation actions
    case litigationPropertiesActions.INSERT_PROPERTY_ERROR: {
      return pushError(state, 'Property with this ID is already exists');
    }
    case litigationCaseActions.FINALIZE_CASE_SUCCESS: {
      return pushSuccess(state, 'Finalize the case');
    }
    case litigationConfigurationActions.UPDATE_CONFIGURATION_ERROR: {
      return pushError(state, 'Updating the configuration');
    }
    case litigationConfigurationActions.UPDATE_CONFIGURATION_SUCCESS: {
      return pushSuccess(state, 'Update the configuration');
    }
    case litigationPartiesActions.UPDATE_PARTY_ERROR: {
      return pushError(state, 'Updating the party');
    }
    case litigationPartiesActions.UPDATE_PARTY_SUCCESS: {
      return pushSuccess(state, 'Party Record Saved');
    }
    case litigationFirmActions.UPDATE_FIRM_ERROR: {
      return pushError(state, 'Updating the firm');
    }
    case litigationFirmActions.UPDATE_FIRM_SUCCESS: {
      return pushSuccess(state, 'Firm Record Saved');
    }

    case litigationFirmActions.INSERT_FIRM_ERROR: {
      return pushError(state, 'Inserting the firm');
    }
    case litigationFirmActions.INSERT_FIRM_SUCCESS: {
      return pushSuccess(state, 'Firm Record Created');
    }

    // assignment actions
    case mobileAssignmentActions.UPDATE_ASSIGNMENT_CRITERIA.ERROR: {
      return pushError(state, 'Updating Assignment Criteria');
    }
    case mobileAssignmentActions.UPDATE_ASSIGNMENT_CRITERIA.SUCCESS: {
      return pushSuccess(state, 'Update Assignment Criteria');
    }
    case mobileSearchActions.DELETE_ASSIGNMENT.ERROR: {
      return pushError(state, 'Deleting Assignment');
    }
    case mobileSearchActions.DELETE_ASSIGNMENT.SUCCESS: {
      return pushSuccess(state, 'Deleted Assignment');
    }

    case mobileAssignmentActions.UPDATE_ASSIGNMENT_QUERY.ERROR: {
      return pushError(state, 'Updating Assignment Query');
    }
    case mobileAssignmentActions.UPDATE_ASSIGNMENT_QUERY.SUCCESS: {
      return pushSuccess(state, 'Update Assignment Query');
    }

    case mobileAssignmentActions.CAPTURE_ASSIGNMENT_PROPERTY.ERROR: {
      return pushError(state, 'Capturing Assignment Property');
    }
    case mobileAssignmentActions.CAPTURE_ASSIGNMENT_PROPERTY.SUCCESS: {
      return pushSuccess(state, 'Capture Assignment Property');
    }

    // success
    // Analysis Actions
    case massUpdateActions.PERFORM_VALUATION_BY_TYPE_MASS_UPDATE.SUCCESS:
      return pushSuccess(state, 'Mass Update Job Created');
    case marketAreaActions.CREATE_MARKET_AREA_COMMERCIAL.SUCCESS:
      return pushSuccess(state, 'Market Area Analysis Created');
    case marketAreaActions.CREATE_MARKET_AREA_COMMERCIAL.ERROR:
      return pushError(state, action.error, 'Creating Market Area Analysis');

    // EquityFinder actions
    case globalEquityFinderActions.CACHE_REFRESH_SUCCESS:
      return pushSuccess(state, 'Refresh Cache');

    case masterActions.MASTER_COPY_SUCCESS:
      return pushSuccess(state, 'Copy Master');
    case masterActions.MASTER_ADD_SUCCESS:
      return pushSuccess(state, 'Add Master');
    case masterActions.MASTER_REMOVE_SUCCESS:
      return pushSuccess(state, 'Remove Master');

    case versionActions.VERSION_REMOVE_SUCCESS:
      return pushSuccess(state, 'Remove Version');
    case versionActions.VERSION_CREATE_SUCCESS:
      return pushSuccess(state, 'Create Version');
    case versionActions.VERSION_SET_ACTIVE_SUCCESS:
      return pushSuccess(state, 'Set Version as Active');
    case versionActions.VERSION_ADD_PROPERTY_SUCCESS:
      return pushSuccess(state, 'Add Property to Version');
    case versionActions.VERSION_COPY_PROPERTY_SUCCESS:
      return pushSuccess(state, 'Copy Version');
    case versionActions.VERSION_REMOVE_PROPERTY_SUCCESS:
      return pushSuccess(state, 'Remove Property from Version');
    case versionActions.VERSION_IMPORT_PROPERTY_SUCCESS:
      return pushSuccess(state, 'Import Property');
    case versionActions.VERSION_DESCRIPTION_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Description');

    case presentationActions.PRESENTATION_DOCUMENT_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Document');
    case presentationActions.PRESENTATION_GLOBALDOCUMENT_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Global Document');
    case presentationActions.PRESENTATION_GLOBALDOCUMENT_UPLOAD_SUCCESS:
      return pushSuccess(state, 'Upload Global Document');
    case presentationActions.PRESENTATION_DOCUMENT_UPLOAD_SUCCESS:
      return pushSuccess(state, 'Upload Document');

    case presentationActions.PRESENTATION_PUBLISH_SUCCESS:
      return pushSuccess(state, 'Publish Presentation');

    case regressionActions.REGRESSION_ANALYSIS_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Regression Analysis');

    case regressionActions.REGRESSION_ANALYSIS_SET_ACTIVE_SUCCESS:
      return pushSuccess(state, 'Set Regression Analysis as Default');

    case regressionActions.REGRESSION_ANALYSIS_CREATE_SUCCESS:
      return pushSuccess(state, 'Create Regression Analysis');

    case regressionActions.REGRESSION_ANALYSIS_PROPERTY_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Regression Analysis Property');

    case regressionActions.REGRESSION_ANALYSIS_COMP_ADD_SUCCESS:
      return pushSuccess(state, 'Add Regression Analysis Comp Properties');

    case configurationsActions.CONFIGURATIONS_CATEGORY_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Category');

    case configurationsActions.CONFIGURATIONS_CATEGORY_ADD_SUCCESS:
      return pushSuccess(state, 'Add Category');

    case configurationsActions.CONFIGURATIONS_CATEGORY_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Category');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULE_ADD_SUCCESS:
      return pushSuccess(state, 'Add Category Regression Rule');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULE_EDIT_SUCCESS:
      return pushSuccess(state, 'Edit Category Regression Rule');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Category Regression Rule');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_ADD_SUCCESS:
      return pushSuccess(state, 'Add Category Regression Rule Set');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_EDIT_SUCCESS:
      return pushSuccess(state, 'Edit Category Regression Rule Set');

    case configurationsActions.CONFIGURATIONS_REGRESSION_RULESET_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Category Regression Rule Set');

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULE_ADD_SUCCESS:
      return pushSuccess(state, 'Add Category Comp Selection Scoring Rule');

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULE_EDIT_SUCCESS:
      return pushSuccess(state, 'Update Category Comp Selection Scoring Rule');

    case configurationsActions.CONFIGURATIONS_COMPSELECTION_RULE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Category Comp Selection Scoring Rule');

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_SUCCESS:
      return pushSuccess(state, 'Add Category Global Scoring Rule');

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_SUCCESS:
      return pushSuccess(state, 'Update Category Global Scoring Rule');

    case configurationsActions.CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Category Global Scoring Rule');

    case configurationsActions.COMPGRID_CONFIGURATIONS_SAVE_SUCCESS:
      return pushSuccess(state, 'Save Comp Grid Configurations');

    case configurationsActions.SYSTEM_CONFIGURATIONS_SAVE_SUCCESS:
      return pushSuccess(state, 'Save System Configurations');

    case configurationsActions.BASE_UNIT_ADD_SUCCESS:
      return pushSuccess(state, 'Add Base Unit');

    case configurationsActions.BASE_UNIT_EDIT_SUCCESS:
      return pushSuccess(state, 'Edit Base Unit');

    case configurationsActions.BASE_UNIT_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Base Unit');

    case configurationsActions.PRODIGY_SCORE_EDIT_SUCCESS:
      return pushSuccess(state, 'Edit Prodigy Score');

    case configurationsActions.TEMPLATE_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Template');

    case configurationsActions.TEMPLATE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Template');

    case configurationsActions.TEMPLATE_CREATE_SUCCESS:
      return pushSuccess(state, 'Create Template');

    case configurationsActions.TEMPLATE_DEFAULT_SET_SUCCESS:
      return pushSuccess(state, 'Set default Template');

    case configurationsActions.TEMPLATE_CATEGORY_ADD_SUCCESS:
      return pushSuccess(state, 'Add a Template to the Category');

    case configurationsActions.TEMPLATE_CATEGORY_REMOVE_SUCCESS:
      return pushSuccess(state, 'Remove a Template from the Category');

    case dataloadActions.DATA_IMPORT_SUCCESS:
      return pushSuccess(state, 'Import Data');

    // Successful Global User Actions
    case globalUserActions.RESET_MFA_SUCCESS:
      return pushSuccess(state, 'MFA has been reset');

    case globalUserActions.RESET_PASSWORD_SUCCESS:
      return pushSuccess(state, 'Password reset email sent');

    // Maintenance actions
    case roleActions.ROLE_CREATE_SUCCESS:
      return pushSuccess(state, 'Create Role');

    case roleActions.ROLE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Role');

    case roleActions.ROLE_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Role');

    case roleActions.RIGHT_ASSIGN_SUCCESS:
      return pushSuccess(state, 'Add Right');

    case roleActions.RIGHT_UNASSIGN_SUCCESS:
      return pushSuccess(state, 'Remove Right');

    case roleActions.ALL_RIGHTS_UNASSIGN_SUCCESS:
      return pushSuccess(state, 'Remove All Rights');

    case usersActions.USER_INACTIVATE_SUCCESS:
      return pushSuccess(state, 'Inactivate User');

    case usersActions.USER_ACTIVATE_SUCCESS:
      return pushSuccess(state, 'Activate User');

    case usersActions.USER_CREATE_SUCCESS:
      return pushSuccess(state, 'Create User');

    case usersActions.USER_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete User');

    case usersActions.USER_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update User');

    case usersActions.USER_MODULE_ROLE_ADD_SUCCESS:
      return pushSuccess(state, 'Add User Module Role');

    case usersActions.USER_MODULE_ROLE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete User Module Role');

    case usersActions.USER_INIT_SUCCESS:
      return pushSuccess(state, 'Check your Email Inbox');

    case usersActions.USER_TAXING_UNITS_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update User Taxing Unit');

    // mra actions
    case mraActions.MRA_MODEL_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete a Model');
    case mraActions.MRA_MODEL_CREATE_SUCCESS:
      return pushSuccess(state, 'Create a Model');
    case mraActions.MRA_MODEL_CALCULATE_SUCCESS:
      return pushSuccess(state, 'Calculate a Model');

    case propertyActions.PROPERTY_COMP_PDF_GENERATE_SUCCESS:
      return pushSuccess(state, 'Generate Comp Grid PDF');

    case propertyActions.PROPERTY_COVER_PDF_GENERATE_SUCCESS:
      return pushSuccess(state, 'Generate Cover Sheet PDF');

    case propertyActions.VERSION_COMPS_REORDER_SUCCESS:
      return pushSuccess(state, 'Reorder Version Comps');

    case appraisalOwnerActions.OWNER_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Owner Detail');

    case appraisalOwnerActions.OWNER_NOTE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Owner note');

    case appraisalOwnerActions.OWNER_NOTE_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Owner note');

    case appraisalOwnerActions.OWNER_NOTE_ADD_SUCCESS:
      return pushSuccess(state, 'Add Owner note');

    case appraisalOwnerActions.OWNER_TAG_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Owner tags');

    case appraisalAgentActions.AGENT_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Agent Detail');

    case appraisalAgentActions.AGENT_NOTE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Agent note');

    case appraisalAgentActions.AGENT_NOTE_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Agent note');

    case appraisalAgentActions.AGENT_NOTE_ADD_SUCCESS:
      return pushSuccess(state, 'Add Agent note');

    case appraisalAgentActions.AGENT_TAG_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Agent tags');

    case appraisalAgentActions.AGENT_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Agent');
    case appraisalAgentActions.AGENT_DELETE_ERROR:
      return pushError(state, action.error, 'Delete Agent');

    case appraisalMortgagelenderActions.MORTGAGELENDER_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Mortgagelender Detail');

    case appraisalMortgagelenderActions.MORTGAGELENDER_NOTE_DELETE_SUCCESS:
      return pushSuccess(state, 'Delete Mortgagelender note');

    case appraisalMortgagelenderActions.MORTGAGELENDER_NOTE_UPDATE_SUCCESS:
      return pushSuccess(state, 'Update Mortgagelender note');

    case appraisalMortgagelenderActions.MORTGAGELENDER_NOTE_ADD_SUCCESS:
      return pushSuccess(state, 'Add Mortgagelender note');

    case globalActions.WARNING:
      return pushWarning(state, action.error);

    case globalActions.SUCCESS:
      return pushSuccess(state, action.message);

    case globalActions.ERROR:
      return pushError(state, action.message);

    case toastActions.TOAST_POP:
      return pop(state);

    // events actions
    case eventsActions.EVENT_FORM_DELETE_SUCCESS:
      return pushSuccess(state, 'Deleting an Event Form');
    case eventsActions.EVENT_FORM_DUPLICATE_SUCCESS:
      return pushSuccess(state, 'Duplicating an Event Form');
    case eventsActions.EVENT_FORM_CREATE_SUCCESS:
      return pushSuccess(state, 'Creating an Event Form');
    case eventsActions.EVENT_FORM_UPDATE_SUCCESS:
      return pushSuccess(state, 'Updating an Event Form');
    case eventsActions.EVENT_TYPES_UPDATE_SUCCESS:
      return pushSuccess(state, 'Updating Event Types');
    case eventsActions.FORM_FIELDS_UPDATE_SUCCESS:
      return pushSuccess(state, 'Updating Form Fields');
    case eventActions.EVENT_DELETE_SUCCESS:
      return pushSuccess(state, 'Deleting an Event');
    case eventActions.EVENT_CREATE_SUCCESS:
      return pushSuccess(state, 'Creating an Event');
    case eventActions.EVENT_UPDATE_SUCCESS:
      return pushSuccess(state, 'Updating an Event');
    case eventActions.EVENT_INACTIVATE_SUCCESS:
      return pushSuccess(state, 'Inactivating an Event');
    case eventActions.EVENT_ACTIVATE_SUCCESS:
      return pushSuccess(state, 'Activating an Event');
    case eventActions.EVENT_UPDATE_TAG_OBJECT_SUCCESS:
      return pushSuccess(state, 'Updating Event Tags/Objects');
    case eventsRolesActions.FORM_ASSOC_CREATE_SUCCESS:
      return pushSuccess(state, 'Creating an Association');
    case eventsRolesActions.FORM_ASSOC_DELETE_SUCCESS:
      return pushSuccess(state, 'Deleting an Association');

    // property appraisal actions
    case appraisalPropertyActions.UPDATE_PERSONAL_RENDITION.SUCCESS:
      return pushSuccess(state, 'Updated Personal Rendition');
    case appraisalPropertyActions.PROPERTY_TAX_DEFERRAL_UPDATE.SUCCESS:
      return pushSuccess(state, 'Updated Tax Deferral Values');
    case appraisalPropertyActions.PROPERTY_UPDATE_BUILDER_ADJUSTMENTS.SUCCESS:
      return pushSuccess(state, 'Builder Adjustment Applied');
    case appraisalPropertyActions.PROPERTY_UPDATE_RENDERED_VALUE.SUCCESS:
      return pushSuccess(state, 'Record Saved');
    case appraisalPropertyActions.UPDATE_PERSONAL_DETAIL.SUCCESS:
      return pushSuccess(state, 'Record Saved');
    case appraisalPropertyActions.UPDATE_OWNERSHIP_PERCENT.SUCCESS:
      return pushSuccess(state, 'Ownership percent successfully updated');
    case appraisalPropertyActions.PROPERTY_CREATE_IMPROVEMENT.SUCCESS:
      return pushSuccess(state, 'Creating property improvement successful');
    case appraisalPropertyActions.PROPERTY_MASS_CREATE_PREP_DATA.ERROR:
      return pushError(
        state,
        action.error.body.error
          ? action.error.body.error.error
          : action.error.body.warning,
      );
    case appraisalPropertyActions.PROPERTY_CREATE_IMPROVEMENT.ERROR:
      return pushError(
        state,
        `Creating property improvement failed.
      ${action.error.body.error.error}`,
      );

    case appraisalPropertyActions.PROPERTY_UPDATE_IMPROVEMENT.SUCCESS:
      return pushSuccess(state, 'Updating property improvement successful');
    case appraisalPropertyActions.PROPERTY_UPDATE_IMPROVEMENT.ERROR:
      return pushError(
        state,
        `Updating property improvement failed.
      ${action.error.body.error.error}`,
      );
    case appraisalPropertyActions.PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES
      .ERROR:
      return pushError(
        state,
        `Updating property improvement features failed.
      ${action.error.body.error.error}`,
      );
    case appraisalPropertyActions.PROPERTY_DELETE_IMPROVEMENT.ERROR:
      return pushError(
        state,
        `Deleting property improvement failed.
        ${action.error.body.error.error}`,
      );
    case appraisalPropertyActions.PROPERTY_UPDATE_IMPROVEMENT_DETAIL.SUCCESS:
      return pushSuccess(
        state,
        'Updating property improvement detail successful',
      );
    case appraisalPropertyActions.PROPERTY_UPDATE_IMPROVEMENT_DETAIL.ERROR:
      if (action.error.body.error) {
        return pushError(
          state,
          `Updating property improvement detail failed.
        ${action.error.body.error.error}`,
        );
      }
      return state;

    case appraisalPropertyActions.PROPERTY_CREATE_IMPROVEMENT_DETAIL.SUCCESS:
      return pushSuccess(
        state,
        'Creating property improvement detail successful',
      );
    case appraisalPropertyActions.PROPERTY_CREATE_IMPROVEMENT_DETAIL.ERROR:
      return pushError(
        state,
        `Creating property improvement detail failed.
        ${action.error.body.error.error}`,
      );

    case appraisalPropertyActions.PROPERTY_CREATE_LAND.SUCCESS:
      return pushSuccess(state, 'Creating property land successful');
    case appraisalPropertyActions.PROPERTY_CREATE_LAND.ERROR:
      return pushError(
        state,
        `Creating property land failed
      ${action.error.body.error.error}`,
      );

    case appraisalPropertyActions.PROPERTY_UPDATE_LAND.SUCCESS:
      return pushSuccess(state, 'Updating property land successful');
    case appraisalPropertyActions.PROPERTY_UPDATE_LAND.ERROR:
      return pushError(
        state,
        `Updating property land failed.
      ${action.error.body.error.error}`,
      );

    case appraisalPropertyActions.COPY_PROPERTY_OTHER_YEARS.SUCCESS: {
      return pushSuccess(state, 'Property Copied');
    }
    case appraisalPropertyActions.COPY_PROPERTY_OTHER_YEARS.ERROR: {
      return pushError(state, 'Copying Property');
    }
    // case appraisalPropertyActions.MOVE_PROPERTY_OTHER_CORRECTION.SUCCESS: {
    //   return pushSuccess(state, 'Property Moved');
    // }
    // case appraisalPropertyActions.MOVE_PROPERTY_OTHER_CORRECTION.ERROR: {
    //   return pushError(state, 'Moving Property');
    // }

    case appraisalPropertyActions.CREATE_APPLICATION_SUCCESS: {
      return pushSuccess(state, 'Application Created');
    }
    case appraisalPropertyActions.CREATE_APPLICATION_ERROR: {
      return pushError(state, action.error.body.error.error);
    }
    case appraisalPropertyActions.UPDATE_APPLICATION_SUCCESS: {
      return pushSuccess(state, 'Application Updated');
    }
    case appraisalPropertyActions.UPDATE_APPLICATION_ERROR: {
      return pushError(state, action.error.body.error.error);
    }

    case appraisalPropertyActions.PROPERTY_CREATE_VALUATION.ERROR: {
      if (action.error.body.error.error.indexOf('is not editable') !== -1) {
        return pushError(
          state,
          'To edit the valuations, please place the property in an open roll correction.',
        );
      }
      return pushError(state, action.error.body.error.error);
    }
    case appraisalPropertyActions.PROPERTY_DELETE_EXEMPTION.ERROR: {
      return pushError(state, 'Deleting property exemption');
    }
    // assessment exemption actions
    case assessmentExemptionActions.CREATE_EXEMPTION_SUCCESS:
      return pushSuccess(state, 'Creating exemption code');
    case assessmentExemptionActions.CREATE_EXEMPTION_ERROR:
      return pushError(state, 'Creating exemption code');
    case assessmentExemptionActions.UPDATE_EXEMPTION_SUCCESS:
      return pushSuccess(state, 'Updating exemption code');
    case assessmentExemptionActions.UPDATE_EXEMPTION_ERROR:
      return pushError(state, 'Updating exemption code');
    case assessmentExemptionActions.DELETE_EXEMPTION_SUCCESS:
      return pushSuccess(state, 'Deleting exemption code');
    case assessmentExemptionActions.DELETE_EXEMPTION_ERROR:
      return pushError(state, 'Deleting exemption code');

    // assessment taxing unit actions
    case assessmentTaxingUnitActions.CREATE_TAXING_UNIT_SUCCESS:
      return pushSuccess(state, 'Creating taxing unit');
    case assessmentTaxingUnitActions.CREATE_TAXING_UNIT_ERROR:
      return pushError(state, 'Creating taxing unit');
    case assessmentTaxingUnitActions.UPDATE_TAXING_UNIT_SUCCESS:
      return pushSuccess(state, 'Updating taxing unit');
    case assessmentTaxingUnitActions.UPDATE_TAXING_UNIT_ERROR:
      return pushError(state, 'Updating taxing unit');
    case assessmentTaxingUnitActions.DELETE_TAXING_UNIT_SUCCESS:
      return pushSuccess(state, 'Deleting taxing unit');
    case assessmentTaxingUnitActions.DELETE_TAXING_UNIT_ERROR:
      return pushError(state, 'Deleting taxing unit');

    // assessment taxing unit pdf library actions
    case assessmentTaxingUnitDocActions.CREATE_DOCUMENT_SUCCESS:
      return pushSuccess(state, 'Creating taxing unit document');
    case assessmentTaxingUnitDocActions.CREATE_DOCUMENT_ERROR:
      return pushError(state, 'Creating taxing unit document');
    case assessmentTaxingUnitDocActions.UPDATE_DOCUMENT_SUCCESS:
      return pushSuccess(state, 'Updating taxing unit document');
    case assessmentTaxingUnitDocActions.UPDATE_DOCUMENT_ERROR:
      return pushError(state, 'Updating taxing unit document');
    case assessmentTaxingUnitDocActions.DELETE_DOCUMENT_SUCCESS:
      return pushSuccess(state, 'Deleting taxing unit document');
    case assessmentTaxingUnitDocActions.DELETE_DOCUMENT_ERROR:
      return pushError(state, 'Deleting taxing unit document');

    case appraisalPropertyActions.PROPERTY_RECALCULATE.ERROR:
      return pushError(state, 'Recalculating Property');
    case appraisalPropertyActions.CHECK_RECALC_PROPERTY.ERROR:
      return pushError(state, 'Checking Recalculation of Property');

    case appraisalPropertyActions.PROPERTY_FETCH_PRIMARY_SITUS.ERROR:
      return pushError(state, 'Could not load property primary situs');
    case appraisalPropertyActions.PROPERTY_FETCH_LEGAL_DESCRIPTION.ERROR:
      return pushError(state, 'Could not load property legal description');

    case appraisalPropertyActions.FETCH_BPP_LATE_RENDITION_PENALTY.ERROR:
      return pushError(state, 'Fetching Late Rendition Penalty');
    case appraisalPropertyActions.UPDATE_BPP_LATE_RENDITION_PENALTY.SUCCESS:
      return pushSuccess(state, 'Updating Late Rendition Penalty');
    case appraisalPropertyActions.UPDATE_BPP_LATE_RENDITION_PENALTY.ERROR:
      return pushSuccess(state, 'Updating Late Rendition Penalty');
    case appraisalPropertyActions.UPDATE_BPP_RENDITION_EXTENSION_REQUESTS
      .SUCCESS:
      return pushSuccess(state, 'Updating Rendition Extension Request');
    case appraisalPropertyActions.UPDATE_BPP_RENDITION_EXTENSION_REQUESTS.ERROR:
      return pushSuccess(state, 'Updating Rendition Extension Request');
    // case appraisalOwnerActions.OWNERSHIP_TRANSFER_SUBMIT[
    //   globalAppraisalActions.SUCCESS
    // ]:
    //   return pushSuccess(state, 'Ownership Transfer Successful');

    case appraisalPropertyActions.PROPERTY_MASS_CREATE_CREATE_PROPERTIES[
      globalAppraisalActions.SUCCESS
    ]:
      return pushSuccess(
        state,
        'Successfully started mass creation of properties',
      );
    case appraisalPropertyActions.PROPERTY_DELETE_TAXING_UNIT.SUCCESS:
      return pushSuccess(state, 'Deleting taxing unit');
    case appraisalPropertyActions.PROPERTY_DELETE_TAXING_UNIT.ERROR:
      return pushError(state, action.error, 'Deleting taxing unit');

    case appraisalEconomicUnitActions.ECONOMIC_UNIT_RECALCULATE.ERROR:
      return pushError(state, 'Could not recalculate the economic unit.');

    case taxMaintenanceActions.FETCH_CHART_SETTINGS.ERROR:
      return pushError(state, action.error, 'Fetching display settings');
    case taxMaintenanceActions.UPDATE_CHART_SETTINGS.ERROR:
      return pushError(state, action.error, 'Updating display settings');
    case taxMaintenanceActions.UPDATE_CHART_SETTINGS.SUCCESS:
      return pushSuccess(state, 'Update display settings');
    case docketActions.MASS_CLOSE_DOCKET.SUCCESS:
      return pushSuccess(state, 'Mass close process started');
    case docketActions.MASS_CLOSE_DOCKET.ERROR:
      return pushError(state, 'Creating mass close process');
    case appealsActions.CREATE_MASS_APPEAL_WITH_AGENT.ERROR:
    case appealsActions.CREATE_MASS_APPEAL_WITH_OWNER.ERROR:
      return pushError(state, action.error, 'Creating Mass Appeals');
    case appealsActions.CREATE_MASS_APPEAL_WITH_AGENT.SUCCESS:
    case appealsActions.CREATE_MASS_APPEAL_WITH_OWNER.SUCCESS:
      return pushSuccess(state, 'Create Mass Appeals');

    case appealsActions.REINITIALIZE_APPEAL_SUMMARY.ERROR:
      return pushError(state, action.error, 'Reinitializing values');
    case appealsActions.REINITIALIZE_APPEAL_SUMMARY.SUCCESS:
      return pushSuccess(state, 'Reinitialize values');

    case appealsActions.UPDATE_APPEALS_SUMMARY.ERROR:
      return pushError(state, action.error, 'Updating Appeal Summary');
    case appealsActions.UPDATE_APPEALS_SUMMARY.SUCCESS:
      return pushSuccess(state, 'Update Appeal Summary');

    case appealsActions.UPDATE_INFORMAL.ERROR:
      return pushError(state, action.error, 'Updating Appeal Informal Review');
    case appealsActions.UPDATE_INFORMAL.SUCCESS:
      return pushSuccess(state, 'Update Appeal Informal Review');

    case appealsActions.UPDATE_APPEAL_GENERAL_INFO.ERROR:
      return pushError(state, action.error, 'Updating Appeal Summary');
    case appealsActions.UPDATE_APPEAL_GENERAL_INFO.SUCCESS:
      return pushSuccess(state, 'Update Appeal Summary');

    case appealsActions.UPDATE_DUE_DILIGENCE.ERROR:
      return pushError(state, action.error, 'Updating Appeal Due Diligence');
    case appealsActions.UPDATE_DUE_DILIGENCE.SUCCESS:
      return pushSuccess(state, 'Update Appeal Due Diligence');

    case appealsActions.APPEAL_UPDATE_CONFIGURATION_GENERAL.ERROR:
      return pushError(state, action.error, 'Updating General Configuration');
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_GENERAL.SUCCESS:
      return pushSuccess(state, 'Update General Configuration');

    case appealsActions.APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS.ERROR:
      return pushError(
        state,
        action.error,
        'Updating Recommendations Configuration',
      );
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS.SUCCESS:
      return pushSuccess(state, 'Update Recommendations Configuration');

    case appealsActions.APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE.ERROR:
      return pushError(
        state,
        action.error,
        'Updating Mass Finalize Configuration',
      );
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE.SUCCESS:
      return pushSuccess(state, 'Update Mass Finalize Configuration');

    case appealsActions.APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET.ERROR:
      return pushError(
        state,
        action.error,
        'Updating Auto Generate Packet Configuration',
      );
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET
      .SUCCESS:
      return pushSuccess(state, 'Update Auto Generate Packet Configuration');

    case appealsActions.APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER.ERROR:
      return pushError(
        state,
        action.error,
        'Updating Auto Offer Configuration',
      );
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER.SUCCESS:
      return pushSuccess(state, 'Update Auto Offer Configuration');
    case appealsActions.INSERT_PRESENTATION_DOCUMENT[
      globalAppraisalActions.ERROR
    ]:
      return pushError(
        state,
        action.error.body.error
          ? action.error.body.error.error
          : action.error.body.warning,
      );
    case appealsActions.DELETE_APPEAL_PANEL.SUCCESS:
      return pushError(state, 'DELETE APPEAL PANEL');
    case appealsActions.DELETE_APPEAL_PANEL.ERROR:
      return pushError(state, action.error, 'DELETE APPEAL PANEL');
    case appraisalAdminDataEntryActions.CREATE_DATA_ENTRY.ERROR:
      return pushError(state, action.error, 'Creating Data Entry Profile');
    case appraisalAdminDataEntryActions.CREATE_DATA_ENTRY.SUCCESS:
      return pushSuccess(state, 'Create Data Entry Profile');
    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY.ERROR:
    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES
      .ERROR:
      return pushError(state, action.error, 'Updating Data Entry Profile');

    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY.SUCCESS:
    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES
      .SUCCESS:
      return pushSuccess(state, 'Update Data Entry Profile');

    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY_PROP_USES.ERROR:
      return pushError(
        state,
        action.error,
        'Updating Data Entry Profile Property Uses',
      );

    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY_PROP_USES.SUCCESS:
      return pushSuccess(state, 'Update Data Entry Profile Property Uses');

    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY_OPTION.ERROR:
      return pushError(
        state,
        action.error,
        'Updating Data Entry Profile Improvement Option',
      );

    case appraisalAdminDataEntryActions.UPDATE_DATA_ENTRY_OPTION.SUCCESS:
      return pushSuccess(state, 'Update Data Entry Profile Improvement Option');

    case appraisalAdminTIRZActions.CREATE_TIRZ.SUCCESS:
      return pushSuccess(state, 'Create TIRZ');

    case appraisalAdminTIRZActions.CREATE_TIRZ.ERROR:
      return pushError(state, action.error, 'Creating TIRZ');

    case appraisalAdminTIRZActions.UPDATE_TIRZ.SUCCESS:
      return pushSuccess(state, 'Update TIRZ');

    case appraisalAdminTIRZActions.UPDATE_TIRZ.ERROR:
      return pushError(state, action.error, 'Updating TIRZ');

    case appraisalAdminBppRenditionActions.UPDATE_CONFIGURATION.SUCCESS:
      return pushSuccess(state, 'Update Configuration');

    case appraisalAdminBppRenditionActions.UPDATE_CONFIGURATION.ERROR:
      return pushError(state, action.error, 'Updating Configuration');

    case appraisalAdminOfficeInfoActions.FETCH_OFFICE_INFO.ERROR:
      return pushError(state, action.error, 'Fetching Office Info');
    case appraisalAdminOfficeInfoActions.UPDATE_OFFICE_INFO.ERROR:
      return pushError(state, action.error, 'Updating Office Info');
    case appraisalAdminOfficeInfoActions.UPDATE_OFFICE_INFO.SUCCESS:
      return pushSuccess(state, 'Update the Office Info');

    case appraisalAdminIncomeModelsActions.INSERT_PRICING_SCHEDULE.ERROR:
      return pushError(state, action.error, 'Creating a Pricing Schedule');
    case appraisalAdminIncomeModelsActions.INSERT_PRICING_SCHEDULE.SUCCESS:
      return pushSuccess(state, 'Create a Pricing Schedule');

    case appraisalAdminIncomeModelsActions.UPDATE_PRICING_SCHEDULE.ERROR:
      return pushError(state, action.error, 'Updating a Pricing Schedule');
    case appraisalAdminIncomeModelsActions.UPDATE_PRICING_SCHEDULE.SUCCESS:
      return pushSuccess(state, 'Updating a Pricing Schedule');

    case appraisalAdminExportActions.EXPORT_APPRAISAL.ERROR:
      return pushError(state, action.error, 'Exporting Appraisal Data');
    case appraisalAdminExportActions.EXPORT_APPRAISAL.SUCCESS:
      return pushSuccess(state, action.data.results);

    case appraisalAdminExportActions.DOWNLOAD_EARS.ERROR:
      return pushError(state, action.error, 'Downloading PTD Export file');

    case appraisalAdminLandModelActions.DELETE_MODEL_LAND_PRICING_SCHEDULE
      .ERROR:
      return pushError(state, action.error, 'Deleting the Pricing Schedule');
    case appraisalAdminLandModelActions.DELETE_MODEL_LAND_PRICING_SCHEDULE
      .SUCCESS:
      return pushSuccess(state, 'Delete the Pricing Schedule');

    case appraisalAdminLandModelActions.SET_MODEL_LAND_PRICING_SCHEDULE_BASE
      .ERROR:
      return pushError(
        state,
        action.error,
        'Setting the Pricing Schedule as a Base Unit Price',
      );
    case appraisalAdminLandModelActions.SET_MODEL_LAND_PRICING_SCHEDULE_BASE
      .SUCCESS:
      return pushSuccess(
        state,
        'Set the Pricing Schedule as a Base Unit Price',
      );
    case appraisalAdminNoticeActions.REMOVE_RUN_TAGS.SUCCESS:
      return pushSuccess(state, 'Remove tags');

    case appraisalAdminNoticeActions.IMPORT_MASS_FILES.SUCCESS:
      return pushSuccess(state, 'Create Mass File');

    case appraisalAdminNoticeActions.IMPORT_MASS_FILES.ERROR:
      return pushError(state, 'Create Mass File');

    case appraisalAdminRecalcActions.CREATE_JOB.SUCCESS:
      return pushSuccess(state, 'Created Recalc Job');

    case appraisalAdminRollCorrectionActions.UPDATE_ROLL_CORR_GROUP[SUCCESS]:
      return pushSuccess(state, 'Updated Roll Correction Group Description');
    case appraisalAdminRollCorrectionActions.UPDATE_ROLL_CORR_GROUP[ERROR]:
      return pushError(
        state,
        action.error,
        'Failed to save Roll Correction Group Description',
      );

    case appraisalAdminAppealCheckInActions
      .FETCH_PROPERTY_LIMITATION_COMPRESSION.ERROR:
      return pushError(state, action.error, 'Compressing Property');

    case appraisalAdminNoticeActions.CREATE_MASS_CREATE_COMP_GRID.ERROR:
      return pushError(state, action.error, 'Creating mass create grids');

    case appraisalAdminGlobalActions
      .DELETE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG.ERROR:
      return pushError(
        state,
        action.error,
        'Deleting Electronic Delivery Request',
      );

    case appraisalAdminGlobalActions.INSERT_MASS_UPDATE_PROPERTY_JOBS[SUCCESS]:
      return pushSuccess(state, 'Insert Mass Update Property Jobs');

    case appraisalAdminGlobalActions.INSERT_MASS_UPDATE_PROPERTY_JOBS[ERROR]:
      return pushError(state, action.error, 'Insert Mass Update Property Jobs');

    case appraisalAdminModelActions.DELETE_ADJUSTMENTS.ERROR:
      return pushError(state, action.error, 'Deleting Adjustment');

    case appraisalAdminModelActions.DELETE_FEATURE.ERROR:
      return pushError(state, action.error, 'Deleting Feature');

    case appraisalAdminModelActions.DELETE_MODEL_FEATURE.ERROR:
      return pushError(state, action.error, 'Deleting Model Feature');

    case pricingTableActions.UPDATE_PRICING_SCHEDULE.SUCCESS:
      return pushSuccess(state, 'Updated Pricing Schedule');

    case pricingTableActions.INSERT_PRICING_SCHEDULE.SUCCESS:
      return pushSuccess(state, 'Inserted Pricing Schedule');

    case biSmartListsActions.INSERT_SMART_LIST.ERROR:
      return pushError(state, action.error, 'Creating a Smart List');
    case biSmartListsActions.UPDATE_SMART_LIST.SUCCESS:
      return pushSuccess(state, 'Smart List Updated');

    case websiteAdminActions.UPDATE_SETTINGS.ERROR:
      return pushError(
        state,
        action.error,
        'Updating the Public Website Settings',
      );
    case websiteAdminActions.UPDATE_SETTINGS.SUCCESS:
      return pushSuccess(state, 'Update the Public Website Settings');

    case queueWorkTypesActions.ADD_WORK_DEFINITION.SUCCESS:
      return pushSuccess(state, 'Create a Work Type Definition');

    case queueWorkTypesActions.ADD_WORK_DEFINITION.ERROR:
      return pushError(state, action.error, 'Creating a Work Type Definition');

    case queueWorkTypesActions.DELETE_WORK_DEFINITION.SUCCESS:
      return pushSuccess(state, 'Delete a Work Type Definition');

    case queueWorkTypesActions.DELETE_WORK_DEFINITION.ERROR:
      return pushError(state, action.error, 'Deleting a Work Type Definition');

    case queueWorkTypesActions.FETCH_WORK_DEFINITIONS.ERROR:
      return pushError(state, action.error, 'Fetching Work Type Definitions');

    case queueWorkTypesActions.UPDATE_WORK_DEFINITION.SUCCESS:
      return pushSuccess(state, 'Update Work Definition');

    case queueWorkTypesActions.UPDATE_WORK_DEFINITION.ERROR:
      return pushError(state, action.error, 'Updating Work Definition');

    case queueWorkTypesActions.ADD_STATUS.SUCCESS:
      return pushSuccess(state, 'Create a Status');

    case queueWorkTypesActions.ADD_STATUS.ERROR:
      return pushError(state, action.error, 'Creating a Status');

    case queueWorkTypesActions.DELETE_STATUS.SUCCESS:
      return pushSuccess(state, 'Delete a Status');

    case queueWorkTypesActions.DELETE_STATUS.ERROR:
      return pushError(state, action.error, 'Deleting a Status');

    case queueWorkTypesActions.FETCH_STATUSES.ERROR:
      return pushError(state, action.error, 'Fetching Statuses');

    case queueWorkTypesActions.ADD_SUBTYPE.SUCCESS:
      return pushSuccess(state, 'Create a Sub Type');

    case queueWorkTypesActions.ADD_SUBTYPE.ERROR:
      return pushError(state, action.error, 'Creating a Sub Type');

    case queueWorkTypesActions.UPDATE_SUBTYPE.SUCCESS:
      return pushSuccess(state, 'Update Sub Type');

    case queueWorkTypesActions.UPDATE_SUBTYPE.ERROR:
      return pushError(state, action.error, 'Updating Sub Type');

    case queueWorkTypesActions.DELETE_SUBTYPE.SUCCESS:
      return pushSuccess(state, 'Delete a Sub Type');

    case queueWorkTypesActions.DELETE_SUBTYPE.ERROR:
      return pushError(state, action.error, 'Deleting a Sub Type');

    case queueWorkTypesActions.FETCH_SUBTYPES.ERROR:
      return pushError(state, action.error, 'Fetching Sub Types');

    case queueWorkTypesActions.SET_DEFAULT_WORK_TYPE.SUCCESS:
      return pushSuccess(state, 'Set as default work type');

    case queueSettingActions.FETCH_QUEUES.ERROR:
      return pushError(state, action.error, 'Fetching Queues');

    case queueSettingActions.FETCH_QUEUE.ERROR:
      return pushError(state, action.error, 'Fetching a Queue');

    case queueSettingActions.UPDATE_QUEUE.SUCCESS:
      return pushSuccess(state, 'Update Queue');

    case queueSettingActions.UPDATE_QUEUE.ERROR:
      return pushError(state, action.error, 'Updating Queue');

    case queueSettingActions.ADD_QUEUE.SUCCESS:
      return pushSuccess(state, 'Create a Queue');

    case queueSettingActions.ADD_QUEUE.ERROR:
      return pushError(state, action.error, 'Creating a Queue');

    case queueSettingActions.DELETE_QUEUE.SUCCESS:
      return pushSuccess(state, 'Delete a Queue');

    case queueSettingActions.DELETE_QUEUE.ERROR:
      return pushError(state, action.error, 'Deleting a Queue');

    case queueSettingActions.FETCH_QUEUE_USERS.ERROR:
      return pushError(state, action.error, 'Fetching Queue Users');

    case queueSettingActions.FETCH_QUEUE_USER.ERROR:
      return pushError(state, action.error, 'Fetching a Queue User');

    case queueSettingActions.UPDATE_QUEUE_USER.SUCCESS:
      return pushSuccess(state, 'Update Queue User');

    case queueSettingActions.UPDATE_QUEUE_USER.ERROR:
      return pushError(state, action.error, 'Updating Queue User');

    case queueSettingActions.ADD_QUEUE_USER.SUCCESS:
      return pushSuccess(state, 'Create a Queue User');

    case queueSettingActions.ADD_QUEUE_USER.ERROR:
      return pushError(state, action.error, 'Creating a Queue User');

    case queueSettingActions.DELETE_QUEUE_USER.SUCCESS:
      return pushSuccess(state, 'Delete a Queue User');

    case queueSettingActions.DELETE_QUEUE_USER.ERROR:
      return pushError(state, action.error, 'Deleting a Queue User');

    case queueSettingActions.UPDATE_QUEUE_WORK_ITEM.SUCCESS:
      return pushSuccess(state, 'Update a Queue Work Item');

    case queueSettingActions.UPDATE_QUEUE_WORK_ITEM.ERROR:
      return pushError(state, action.error, 'Updating a Queue Work Item');

    case queueSettingActions.CHANGE_WORK_ITEM_ORDER.ERROR:
      return pushError(state, action.error, 'Changing a Queue Work Item Order');

    case queueSettingActions.CHANGE_WORK_ITEM_ORDER.SUCCESS:
      return pushSuccess(state, 'Change a Queue Work Item Order');

    case queueSettingActions.FINALIZE_WORK_ITEM.SUCCESS:
      return pushSuccess(state, 'Finalize a Queue Work Item');

    case queueSettingActions.FINALIZE_WORK_ITEM.ERROR:
      return pushError(state, action.error, 'Finalizing a Queue Work Item');

    case queueSettingActions.SHARE_VIRTUAL_ROOM.SUCCESS:
      return pushSuccess(state, 'Share a Virtual Room');

    case queueSettingActions.SHARE_VIRTUAL_ROOM.ERROR:
      return pushError(state, action.error, 'Sharing a Virtual Room');

    case queueSettingActions.ADD_WORK_ITEM_ATTACHMENT.SUCCESS:
      return pushSuccess(state, 'Add a Queue Work Item Attachment');

    case queueSettingActions.ADD_WORK_ITEM_ATTACHMENT.ERROR:
      return pushError(
        state,
        action.error,
        'Adding a Queue Work Item Attachment',
      );

    case queueSettingActions.ADD_WORK_ITEM_PROPERTY.SUCCESS:
      return pushSuccess(state, 'Add a Queue Work Item Property');

    case queueSettingActions.ADD_WORK_ITEM_PROPERTY.ERROR:
      return pushError(
        state,
        action.error,
        'Adding a Queue Work Item Property',
      );

    case queueSettingActions.DELETE_WORK_ITEM_PROPERTY.SUCCESS:
      return pushSuccess(state, 'Delete a Queue Work Item Property');

    case queueSettingActions.DELETE_WORK_ITEM_PROPERTY.ERROR:
      return pushError(
        state,
        action.error,
        'Deleting a Queue Work Item Property',
      );

    case queueSettingActions.DELETE_WORK_ITEM_ATTACHMENT.SUCCESS:
      return pushSuccess(state, 'Delete a Queue Work Item Attachment');

    case queueSettingActions.DELETE_WORK_ITEM_ATTACHMENT.ERROR:
      return pushError(
        state,
        action.error,
        'Delete a Queue Work Item Attachment',
      );

    case queueSettingActions.ADD_WORK_ITEM_APPEAL.SUCCESS:
      return pushSuccess(state, 'Add a Queue Work Item Appeal');

    case queueSettingActions.ADD_WORK_ITEM_APPEAL.ERROR:
      return pushError(state, action.error, 'Adding a Queue Work Item Appeal');

    case queueSettingActions.DELETE_WORK_ITEM_APPEAL.SUCCESS:
      return pushSuccess(state, 'Delete a Queue Work Item Appeal');

    case queueSettingActions.DELETE_WORK_ITEM_APPEAL.ERROR:
      return pushError(state, action.error, 'Delete a Queue Work Item Appeal');

    case queueSettingActions.ADD_WORK_ITEM_DEED.SUCCESS:
      return pushSuccess(state, 'Add a Queue Work Item Deed');

    case queueSettingActions.ADD_WORK_ITEM_DEED.ERROR:
      return pushError(state, action.error, 'Adding a Queue Work Item Deed');

    case queueSettingActions.DELETE_WORK_ITEM_DEED.SUCCESS:
      return pushSuccess(state, 'Delete a Queue Work Item Deed');

    case queueSettingActions.DELETE_WORK_ITEM_DEED.ERROR:
      return pushError(state, action.error, 'Delete a Queue Work Item Deed');

    case queueSettingActions.ADD_WORK_ITEM_EVENT.SUCCESS:
      return pushSuccess(state, 'Add a Queue Work Item Event');

    case queueSettingActions.ADD_WORK_ITEM_EVENT.ERROR:
      return pushError(state, action.error, 'Adding a Queue Work Item Event');

    case queueSettingActions.DELETE_WORK_ITEM_EVENT.SUCCESS:
      return pushSuccess(state, 'Delete a Queue Work Item Event');

    case queueSettingActions.DELETE_WORK_ITEM_EVENT.ERROR:
      return pushError(state, action.error, 'Delete a Queue Work Item Event');

    case queueSettingActions.ADD_WORK_ITEM_BUILDING_PERMIT.SUCCESS:
      return pushSuccess(state, 'Add a Queue Work Item Building Permit');

    case queueSettingActions.ADD_WORK_ITEM_BUILDING_PERMIT.ERROR:
      return pushError(
        state,
        action.error,
        'Adding a Queue Work Item Building Permit',
      );

    case queueSettingActions.DELETE_WORK_ITEM_BUILDING_PERMIT.SUCCESS:
      return pushSuccess(state, 'Delete a Queue Work Item Building Permit');

    case queueSettingActions.DELETE_WORK_ITEM_BUILDING_PERMIT.ERROR:
      return pushError(
        state,
        action.error,
        'Delete a Queue Work Item Building Permit',
      );

    case queueGlobalActions.UPLOAD_FILE.SUCCESS:
      return pushSuccess(
        state,
        'Upload a Queue Batch Import Run Property Barcode',
      );

    case queueGlobalActions.UPLOAD_FILE.ERROR:
      return pushError(
        state,
        action.error,
        'Upload a Queue Batch Import Run Property Barcode',
      );

    case batchProcessingActions.CREATE_WORK_ITEMS.SUCCESS:
      return pushSuccess(state, 'Create work items');

    case batchProcessingActions.CREATE_WORK_ITEMS.ERROR:
      return pushError(state, action.error, 'Creating work items');

    case batchProcessingActions.FETCH_BATCH_PROCESSING.ERROR:
      return pushError(state, action.error, 'Fetching Import listing');

    case batchProcessingActions.CLOSE_PROCESS.SUCCESS:
      return pushSuccess(state, 'Close the run');

    case batchProcessingActions.CLOSE_PROCESS.ERROR:
      return pushError(state, action.error, 'Closing the run');

    case batchProcessingActions.VALIDATE_LINKED_OBJECTS.ERROR:
      return pushError(state, action.error, 'Validating the object');

    case bppPenaltyActions.UPDATE_BPP_PENALTY_CONFIGURATION.SUCCESS:
      return pushSuccess(state, 'Update the configuration');

    case bppPenaltyActions.UPDATE_BPP_PENALTY_CONFIGURATION.ERROR:
      return pushError(state, action.error, 'Updating the configuration');

    case buildingPermitActions.INSERT_BUILDING_PERMIT_CONFIGURATION.SUCCESS:
      return pushSuccess(state, 'Create a configuration');

    case buildingPermitActions.INSERT_BUILDING_PERMIT_CONFIGURATION.ERROR:
      return pushError(state, action.error, 'Creating a configuration');

    case buildingPermitActions.UPDATE_BUILDING_PERMIT_CONFIGURATION.SUCCESS:
      return pushSuccess(state, 'Update the configuration');

    case buildingPermitActions.UPDATE_BUILDING_PERMIT_CONFIGURATION.ERROR:
      return pushError(state, action.error, 'Updating the configuration');

    case appraisalBuildingPermitActions.BUILDING_PERMIT_MASS_UPDATE_STATUS_SUCCESS:
      return pushSuccess(state, 'Mass Update Status');

    case appraisalBuildingPermitActions.BUILDING_PERMIT_MASS_UPDATE_STATUS_ERROR:
      return pushError(state, action.error, 'Mass Updating Status');

    case appraisalBuildingPermitActions.BUILDING_PERMIT_MASS_REMATCH_SUCCESS:
      return pushSuccess(state, 'Mass Re-Match');

    case appraisalBuildingPermitActions.BUILDING_PERMIT_MASS_REMATCH_ERROR:
      return pushError(state, action.error, 'Mass Re-Matching');

    case ptdProcessActions.UPDATE_PTD_CONFIGURATION.SUCCESS:
      return pushSuccess(state, 'Update the configuration');

    case ptdProcessActions.UPDATE_PTD_CONFIGURATION.ERROR:
      return pushError(state, action.error, 'Updating the configuration');

    case ptdProcessActions.ADD_CLIENT_MAPPING.SUCCESS:
      return pushSuccess(state, 'Add client mapping');

    case ptdProcessActions.ADD_CLIENT_MAPPING.ERROR:
      return pushError(state, action.error, 'Adding client mapping');

    case ptdProcessActions.UPDATE_CLIENT_MAPPING.SUCCESS:
      return pushSuccess(state, 'Update the client mapping');

    case ptdProcessActions.UPDATE_CLIENT_MAPPING.ERROR:
      return pushError(state, action.error, 'Updating the client mapping');

    case ptdProcessActions.DELETE_CLIENT_MAPPING.SUCCESS:
      return pushSuccess(state, 'delete the client mapping');

    case ptdProcessActions.DELETE_CLIENT_MAPPING.ERROR:
      return pushError(state, action.error, 'deleting the client mapping');

    case mobilePropertyActions.APPROVE_PROPERTY_CHANGES_SUCCESS:
      return pushSuccess(state, 'Property changes were approved');
    case mobilePropertyActions.REJECT_PROPERTY_CHANGES_SUCCESS:
      return pushSuccess(state, 'Property changes were rejected');

    case mobilePropertyActions.APPROVE_PROPERTY_CHANGES_ERROR:
      return pushError(
        state,
        action.error,
        'Property changes could not be approved',
      );
    case mobilePropertyActions.REJECT_PROPERTY_CHANGES_ERROR:
      return pushError(
        state,
        action.error,
        'Property changes could not be rejected',
      );

    case appraisalPropertyActions.PROPERTY_RENDITION_CREATE.SUCCESS: {
      return pushSuccess(state, 'Rendition Created');
    }
    case appraisalPropertyActions.PROPERTY_RENDITION_CREATE.ERROR: {
      return pushError(state, action.error.body.error.error);
    }

    // Conferencing
    case conferencingActions.CREATE_WAITING_ROOM_CONFIG[SUCCESS]: {
      return pushSuccess(state, 'Waiting Room Created');
    }
    case conferencingActions.CREATE_WAITING_ROOM_CONFIG[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }

    case conferencingActions.UPDATE_WAITING_ROOM_CONFIG[SUCCESS]: {
      return pushSuccess(state, 'Waiting Room Saved');
    }
    case conferencingActions.UPDATE_WAITING_ROOM_CONFIG[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }

    case conferencingActions.INSERT_CHECK_IN_PROPERTIES[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }

    case conferenceActions.UPDATE_ATTENDEE_CAPABILITIES[SUCCESS]: {
      return pushSuccess(state, 'Attendee Updated');
    }
    case conferenceActions.UPDATE_ATTENDEE_CAPABILITIES[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.START_RECORDING_APPEAL[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.END_APPEAL_RECORDING[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.START_RECORDING[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.END_RECORDING[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.START_HEARING[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.START_HEARING_INFORMAL[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.END_HEARING[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.END_HEARING_INFORMAL[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.JOIN_CHIME_CONFERENCE[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.END_CHIME_CONFERENCE[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.UPDATE_MEETING_ATTENDEE_INFO[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.REMOVE_ATTENDEE_FROM_CONFERENCE[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_ATTENDEES[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_ATTENDEE_BY_ID[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.DIAL_OUT[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.CREATE_CONFERENCE[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_CHIME_CONFERENCE[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_MEETING_INFORMATION[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_ATTENDEE_HISTORY[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.SEND_MEETING_INFO[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_CURRENT_CONFERENCES[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.FETCH_PAST_CONFERENCES[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }
    case conferenceActions.DOWNLOAD_CONFERENCE_RECORDING[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }

    case conferencingActions.DELETE_WAITING_ROOM_CONFIG[SUCCESS]: {
      return pushSuccess(state, 'Waiting Room Configuration Removed');
    }
    case conferencingActions.DELETE_WAITING_ROOM_CONFIG[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }

    case captureJanuary1OwnersActions.ADD_CAPTURE_JANUARY1_OWNERS_RUN[
      SUCCESS
    ]: {
      return pushSuccess(state, 'Capture January 1 Owner Process Started');
    }
    case captureJanuary1OwnersActions.ADD_CAPTURE_JANUARY1_OWNERS_RUN[ERROR]: {
      return pushError(state, action.error.body.error.error);
    }

    case massMatchSalesActions.CREATE_MASS_LINK_SALE_TO_DEEDS[ERROR]: {
      return pushError(
        state,
        action.error,
        'Creating Mass Match Sales width Deeds',
      );
    }

    case massMatchSalesActions.MATCH_MASS_LINK_SALE_TO_DEEDS[ERROR]: {
      return pushError(
        state,
        action.error,
        'Matching Mass Match Sales width Deeds',
      );
    }

    case massMatchSalesActions.FINALIZE_MASS_LINK_SALE_TO_DEEDS[ERROR]: {
      return pushError(
        state,
        action.error,
        'Finalizing Mass Match Sales width Deeds',
      );
    }

    default:
      return state;
  }
};
